import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import { FontVariantToken } from '@uipath/apollo-core';
import React from 'react';
import { useIntl } from 'react-intl';

interface ModelInformationSectionProps {
    titleKey?: string;
    descriptionKey?: string;
}

export const ModelInformationSection: React.FC<ModelInformationSectionProps> = ({
    titleKey, descriptionKey,
}) => {
    const { formatMessage: translate } = useIntl();

    return (
        <UiStack
            direction='column'
            gap={SpacingToken.XS}>
            {titleKey && (
                <UiText variant={FontVariantToken.fontSizeMBold}>
                    {translate({ id: titleKey })}
                </UiText>
            )}
            {descriptionKey && (
                <UiText>
                    {translate({ id: descriptionKey })}
                </UiText>
            )}
        </UiStack>);
};
